module.exports = __webpack_public_path__ + "c9eee7e434fc31112dce1c81f3a33c76.MP3";